import React, { lazy } from 'react';
import { Route } from 'react-router';

const ScoringByRubricContainer = lazy(
  () => import('legacy-src/components/scoring/ScoringByRubricContainer'),
);

const ScoringLayout = lazy(
  () => import('legacy-src/components/scoring/ScoringLayout'),
);

// for AP Readers we create a limited UI base of the Scoring UI
// e.g. /frq-pc-result/{$AssignmentId}/students/{$StudentId}

export default (
  <Route
    name="frq-pc-result"
    path="frq-pc-result/:assignmentId/students/:studentId"
    component={ScoringByRubricContainer}
  >
    <Route path="questions/:questionId" component={ScoringLayout} />
  </Route>
);
